var _ = require('lodash');
var moment = require('moment');
(function Module() {
	'use strict';

    mySynch.directive('tableSortable', ['$rootScope',function (rootScope) {
            return {
                        restrict: 'E',
                        transclude: true,
                        templateUrl: '../partials/directive-templates/table.sortable.view.html',
                        scope: {
                            columns: '=',
                            data: '=',
                            sort: '='
                        },
                        link: function (scope, element, attrs) {

                           
                           //--------------------------------------
                           // data initialization
                           
                            scope.elementRef = element;
                           
                            scope.indexColumnValueField = _.get(_.find(scope.columns,{isIndex:true}),'variable');
                            scope.indexColumnKeyIndex = 0;
                            var keys = _.keys(_.get(scope,'data[0]',{}));
                             if(!_.isEmpty(keys)){
                                 scope.indexColumnKeyIndex = _.indexOf(keys,scope.indexColumnValueField);
                             }



                            //--------------------------------------

                             scope.getCleanIndexValue = function getCleanIndexValue(value){
                               var cleanedValue = "";
                                 _.forEach(value.toString().split(" "),function(valPart){
                                        valPart = _.trim(valPart);
                                        valPart = valPart.replace(/"'"/g,"");
                                        valPart = valPart.replace(/"-"/g,"");
                                       if(!_.isEmpty(valPart)){
                                           cleanedValue += valPart;
                                       }
                                 });
                                 return cleanedValue;
                             };
                            
                            scope.getRandomArbitrary = function(min, max) {
                                return Math.random() * (max - min) + min;
                            };

                           // scope.subMenuId = scope.getRandomArbitrary(0,10000);
                           
                            scope.selectedClass = function (columnName) {
                                return columnName == scope.sort.column ? 'sort-' + scope.sort.descending+" "+_.get(_.find(scope.columns,{variable: columnName}),"headerCellClass","") : _.get(_.find(scope.columns,{variable: columnName}),"headerCellClass","");
                            };
                            scope.changeSorting = function (columnName) {
                                var sort = scope.sort;
                                if (sort.column == columnName) {
                                    sort.descending = !sort.descending;
                                } else {
                                    sort.column = columnName;
                                    sort.descending = false;
                                }
                            };
                            scope.getFilterOfColumn = function (columnName) {
                                for (var i = 0; i < scope.columns.length; i++) {
                                    if (columnName == scope.columns[i].filterVariable)
                                        return scope.columns[i].filter;
                                }
                                return '';
                            };
                            
                           
                          

                        },
                        controller: ["$scope","$compile","MySynchFactory",
                            function($scope,$compile,MSF) {
                                
                                var dataWatchDereg = undefined;
                                $scope.getDirectiveHtml = function getDirectiveHtml(){
                                    return $compile(directiveHtmlString)($scope);
                                };

                                $scope.toggleBodyCellTooltip = function toggleBodyCellTooltip(object,tooltipShowVariableName,show){
                                     object[tooltipShowVariableName] = show;
                                };

                                dataWatchDereg = $scope.$watch('data',function(newVal,oldVal){
                              
                                    if(newVal.length > 0)  {
                                        var firstDataRowIndexValue = _.get(newVal[0],$scope.indexColumnValueField,"");
                                        var firstDataRowVisibleFieldName = _.get(_.find($scope.columns,{showInTable:true}),"variable");

                                        var firstDataRowCSSSelector = "#bodyCell-"+firstDataRowVisibleFieldName+"-"+firstDataRowIndexValue;

                                         MSF.waitForElm(firstDataRowCSSSelector).then(function(result){
                                            rootScope.$broadcast("table-sortable:data-swapped", {tableSortableElm: $scope.elementRef});
                                         });
                                        
                                    }
                                    if(oldVal.length > 0 && newVal.length == 0)  {
                                      rootScope.$broadcast("table-sortable:data-swapped", {tableSortableElm: $scope.elementRef});
                                    }

                                });
                           

                                $scope.$on("$destroy", function() {
			
                                    if(!_.isUndefined(dataWatchDereg)){
                                        console.log("table sortable data watch deregistered");
                                        dataWatchDereg();
                                    }
                     
                                    
                                 });

                                 rootScope.$broadcast("table-sortable:loaded", {tableSortable: this});


                            }
                        ]
                    };

    }]);
})();